import { render, staticRenderFns } from "./list.vue?vue&type=template&id=38d91cdf&scoped=true&"
import script from "./list.vue?vue&type=script&lang=js&"
export * from "./list.vue?vue&type=script&lang=js&"
import style0 from "./list.vue?vue&type=style&index=0&id=38d91cdf&prod&lang=less&scoped=true&"
import style1 from "./list.vue?vue&type=style&index=1&id=38d91cdf&prod&lang=less&"
import style2 from "./list.vue?vue&type=style&index=2&id=38d91cdf&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d91cdf",
  null
  
)

export default component.exports